import {CollectionType} from "../../data/enums/CollectionType";

export class CreateCollectionRequest {

	name: string;
	products: Array<string>; // product's ids
	type: CollectionType;

}
